import { useBrand } from "../theme/ThemeProvider";
import { BrandLogo } from "../theme/BrandLogo";
import { loginUrl, devLoginUrl } from "../lib/api";

// Launch landing (open signup — A6). Two CTAs by design: the worker maps
// ``?intent=signup`` and ``?intent=signin`` to the WorkOS ``screen_hint``
// so AuthKit shows the right form first. "Start free trial" is the
// new-user CTA — /auth/callback provisions + redirects it to /welcome
// to pick a plan; "Sign in" is for returning users (lands on /dashboard,
// or /welcome if their account is still locked).
export function SignIn() {
  const brand = useBrand();
  return (
    <div className="center signin">
      <div className="signin-card">
        <div className="signin-mark">
          {/* Decorative: the product name is right below as an H1,
              so the logo doesn't need its own screen-reader label. */}
          <BrandLogo alt="" />
        </div>
        <h1 className="signin-title">{brand.productName}</h1>
        <p className="signin-tagline">{brand.tagline}</p>

        <div className="signin-actions">
          <a className="btn signin-cta" href={loginUrl("signup")}>
            Start free trial
          </a>
          <a
            className="btn secondary signin-cta"
            href={loginUrl("signin")}
          >
            Sign in
          </a>
          {/* Local-dev only: skips WorkOS entirely (see devLoginUrl).
              Vite strips this branch from production builds. */}
          {import.meta.env.DEV && (
            <a className="btn secondary signin-cta" href={devLoginUrl()}>
              Dev sign-in (local)
            </a>
          )}
        </div>

        <p className="signin-help">
          Every plan starts with a 14-day free trial.
        </p>

        <p className="signin-fineprint">
          <a href="https://plaingraph.com/#showcase">
            Browse sample companies
          </a>
          <br />
          Need help? <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>
        </p>
      </div>
    </div>
  );
}
